import * as storage from '../storage'
export default {
  itens: storage.getItensCarrinho() || [],
  cupomData: storage.getCupomDataDoCarrinho() || {}
}
